export default __webpack_public_path__ + "static/logo_nocopy-208f3df7246833a3e7c499f20515fe5f.svg";